import { TProjectData } from "../model/types";

export const MAX_FILES = 20;
export const MAX_TOTAL_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
export const ACCEPTED_FILE_TYPES = ".pdf,.pptx,.jpg,.jpeg,.png,.txt,.csv,.xlsx,.xls,.xlsm,.docx";
export const ACCEPTED_LOGO_TYPES = ".jpg,.jpeg,.png";
export const initialProjectData: TProjectData = {
  name: "",
  projectTemplateSlug: "",
  description: "",
  repository: [],
  language: "english",
  decisionContext: "",
  successMetrics: "",
  targetAudience: "",
  additionalContext: "",
  chaptersInstructions: {},
  projectInstructions: "",
  presentationPrompt: "",
  dimensionValues: {}
};

// `endonym` is the language's name in itself and is never translated, so a picker can show it
// beside the translated name — someone who has set the interface to a language they cannot read
// still needs to recognise their own.
export const languageOptions = [
  { value: "english", label: "English", endonym: "English" },
  { value: "japanese", label: "Japanese", endonym: "日本語" }
] as const;
